import {of} from "rxjs"
import {catchError, filter, mergeMap, switchMap} from "rxjs/operators"
import {actionFactory, actionTypes} from "@/api/identity/IdentityReducer"

const IdentityEpics = {
  uploadSecureCaptureSelfie: (epic$, {identityApi}) => {
    return epic$.pipe(
      filter(({action}) => action.type === actionTypes.uploadSecureCaptureSelfie),
      switchMap(({action: {payload}, currState}) =>
        identityApi.captureSecureSelfie({payload, apiKey: currState.apiKey})
          .pipe(
            mergeMap(() => {
              return of(actionFactory.uploadSecureCaptureSelfieCompleted({}))
            }),
            catchError((error) => {
              return of(actionFactory.uploadSecureCaptureSelfieFailed(error))
            }),
          )
      )
    )
  },
}

// convert object into an array of functions
export default Object.keys(IdentityEpics).map(k => IdentityEpics[k])
